import { twMerge } from 'tailwind-merge';

const CLASS_NAME = 'text-red-500 text-xs';

export const ErrorMessage = ({ errorMessage, className }) => {
  return <p className={twMerge(CLASS_NAME, className)}>{errorMessage}</p>;
};
